import React from 'react';
import OverflowingText from '../../components/foundations/OverflowingText';
import TruncatedNote from './TruncatedNote';
import { TRANSLATION_KEY } from '../constants';
import { breakdownTableViewShape } from '../propShapes';
import { formatVerdictValue } from '../verdictFormat';
import css from './BreakdownTable.css';

const BreakdownTable = ({ view }) => (
    <div>
        <div className={css.tableWrap}>
            <table className={css.table}>
                <thead>
                    <tr>
                        <th className={css.entityHeader} aria-label="Entity" />
                        {view.columns.map(column => (
                            <th key={column.key} className={css.valueHeader}>
                                {column.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {view.rows.map((row, index) => (
                        <tr key={`${row.label}-${index}`}>
                            <td className={css.entityCell}>
                                <OverflowingText className={css.entityLabel}>{row.label}</OverflowingText>
                            </td>
                            {view.columns.map(column => (
                                <td key={column.key} className={css.valueCell}>
                                    {formatVerdictValue(row.values[column.key], column.display_format)}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        <TruncatedNote count={view.truncated_count} translationId={`${TRANSLATION_KEY}.CARD.MORE_RESULTS`} />
    </div>
);

BreakdownTable.propTypes = {
    view: breakdownTableViewShape.isRequired,
};

export default BreakdownTable;
